module.exports = __webpack_public_path__ + "static/media/black-tshirt-man-back-min.c8602d72.png";